export const statisticOrientations = {
  vertical: 'vertical',
  horizontal: 'horizontal',
}

export const statisticSizes = {
  large: 'large',
  small: 'small',
}

export const statisticStatuses = {
  default: 'default',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
}

export const alertStatuses = [statisticStatuses.warning, statisticStatuses.danger]

export const statisticTextTypes = {
  [statisticSizes.large]: {
    label: 'allCapsM',
    value: 'titleL',
    suffix: 'titleM',
    caption: 'bodySRegular',
  },
  [statisticSizes.small]: {
    label: 'allCapsS',
    value: 'titleM',
    suffix: 'titleS',
    caption: 'bodyXSRegular',
  },
}

export const statisticSkeletonDimensions = {
  [statisticSizes.large]: {
    label: { width: 120, height: 16 },
    value: { width: 72, height: 24 },
    caption: { width: 140, height: 16 },
  },
  [statisticSizes.small]: {
    label: { width: 88, height: 12 },
    value: { width: 56, height: 18 },
    caption: { width: 104, height: 12 },
  },
}
